module.exports = __webpack_public_path__ + "static/img/ini.7ce7354.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/ini.png
// module id = RDmM
// module chunks = 53